import React from "react";
import Navbar from "./shared/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "./shared/Footer";

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      {/*<div className="mt-56 lg:mt-24 md:mt-20 sm:mt-14 xs:mt-12"></div>*/}
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
